export const clients = {
	place: "Lugar",
	titleWithPlace: "Lista de clientes",
	searchTitle: "Tipo de documento",
	searchPlaceholder: "Ingrese el documento",
	searchClientByName: "Ingrese el nombre",
	documentTypePlaceHolder: "Seleccione el tipo de documento",
	filterTitle: "Filtros avanzados",
	filterByProductTitle: "Filtrar por producto",
	clearFilter: "Limpiar todos los campos",
	applyFilter: "Aplicar filtros",
	productError: "La cantidad de {{product}} debe ser mayor que cero",
	filter: {
		period: "Período",
		gender: "Género",
		genderPlaceholder: "Seleccione el/los género(s)",
		periodFrequency: "Frecuencia",
		firstTime: "1ª vez",
		frequencyPlaceholder: "Elija la frecuencia del cliente",
		daysOfTheWeek: "Días de la semana",
		daysOfTheWeekPlaceholder: "Seleccione los días de la semana",
		productsConsumed: "Productos consumidos",
		product: "Producto",
		selectProduct: "Seleccione un producto",
		noProducts: "Ningún producto encontrado",
		quantity: "Cantidad",
		removeProduct: "Eliminar producto",
		addProduct: "Agregar otro producto",
		consumptionVolume: "Consumo mínimo",
		notUsedRecharges: "Residuo de recarga mínima",
		birthdateRange: "Período de Cumpleaños",
		birthdateYear: "Año de Cumpleaños",
		yearPlaceholder: "aaaa",
		products: "Producto(s)",
		productsPlaceholder: "Seleccione el/los producto(s)",
		errors: {
			type: "Datos inválidos",
			birthdate: {
				year: "Ingrese un año entre 1900 y el año actual",
			},
		},
	},
	table: {
		name: "Cliente",
		cpf: "CPF",
		phone: "Teléfono",
		birthDate: "Fecha de cumpleaños",
		uninformed: "No informado",
		email: "E-mail",
		presences: "Presencia",
		consumption: "Consumió",
		remaningValueOnPlace: "Saldo disponible",
		hasApp: "Aplicación activa",
		moreThan: "más de ",
		countClients_one: "cliente encontrado",
		countClients_other: "clientes encontrados",
		countTicketClients: "ticket promedio por cliente",
		infoLabel: "Seleccione un cliente para ver detalles.",
		infoLabelTable: "Seleccione una Mesa para ver detalles.",
		emptyText: "Sin datos para mostrar",
		moreResults: "Cargar más resultados",
		firstTimeAtPlace: "1ª vez",
		lastTimeAtPlace: "Última visita",
	},
	cancel: "Cancelar",
	search: "Buscar",
	gender: {
		male: "Hombre",
		female: "Mujer",
		others: "Otros",
	},
	daysOfTheWeek: {
		monday: "Lunes",
		tuesday: "Martes",
		wednesday: "Miércoles",
		thursday: "Jueves",
		friday: "Viernes",
		saturday: "Sábado",
		sunday: "Domingo",
	},
};
